import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//data inicial
const dataInicial = {
    data: {},
    fc_06: {
        fechafolicitud: fechaHoy,
        domiciliosolicitante: '',
        nombreresponsable: '',
        telefono: '',
        predio: false,
        vivero: false
    },
    predios: [],
    prediosMap: [],
    viverosMap: [],
    filesPrediosMap: [],
    filesViverosMap: [],
    viveros: [],
    viverosMap: [],
    fc_06Map: {},
    loading: false,
    modoEdicionBorrador: false,
    modoCorreccion: false,
    paginaActiva: 1,
    cliente: [],
    dataLogin: [],
    filesPredios: [],
    filesViveros: [],
    opcionesFilePredio: [],
    opcionesFileVivero: [],
    domiclio: ''
}

//types
const OBTENER_FC_06_DETALLE_EXITO = 'OBTENER_FC_06_DETALLE_EXITO'
const OBTENER_FC_06_MAP_EXITO = 'OBTENER_FC_06_MAP_EXITO'
const FC_06_SOLICITUD_EXITO = 'FC_06_SOLICITUD_EXITO'
const FC_06_ANEXO_PREDIO_SOLICITUD_EXITO = 'FC_06_ANEXO_PREDIO_SOLICITUD_EXITO'
const AGREGAR_FC_06_BORRADOR_EXITO = 'AGREGAR_FC_06_BORRADOR_EXITO'
const ACTUALIZAR_FC_06_ESTATUS_EXITO = 'ACTUALIZAR_FC_06_ESTATUS_EXITO'
const ELIMINAR_FC_06_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_06_SOLICITUD_EXITO_BD'
const ELIMINAR_FC_06_ANEXOPREDIO_EXITO_BD = 'ELIMINAR_FC_06_ANEXOPREDIO_EXITO_BD'
const OBTENER_CLIENTE_POR_LOGIN_EXITO_06 = 'OBTENER_CLIENTE_POR_LOGIN_EXITO_06'
const OBTENER_FC_06_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_06_CONTADOR_FECHA_FOLIO_EXITO'
const AGREGAR_FC_06_EXITO = 'AGREGAR_FC_06_EXITO'
const AGREGAR_ARCHIVO_FC_06_EXITO = 'AGREGAR_ARCHIVO_FC_06_EXITO'
const ACTUALIZAR_ARCHIVO_FC_06_EXITO = 'ACTUALIZAR_ARCHIVO_FC_06_EXITO'
const ELIMINAR_ARCHIVO_FC_06_EXITO = 'ELIMINAR_ARCHIVO_FC_06_EXITO'
const AGREGAR_FC_06_FECHA_EXITO = 'AGREGAR_FC_06_FECHA_EXITO'
const ACTUALIZAR_FC_06_SOLICITUD = 'ACTUALIZAR_FC_06_SOLICITUD'
const ELIMINAR_FC_06_ANEXOVIVERO_EXITO_BD = 'ELIMINAR_FC_06_ANEXOVIVERO_EXITO_BD'
const ACTUALIZAR_FC_06_BORRADOR_EXITO = 'ACTUALIZAR_FC_06_BORRADOR_EXITO'
export const ObtenerClientePorLogin06 = createAsyncThunk(
    OBTENER_CLIENTE_POR_LOGIN_EXITO_06,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${params.idlogin}`

            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            let idcartera = res.data.data.idcartera
            const fullUrlDatosLogin = host + `AnexoUsuario/obtenerDatosLoginPorCartera/${idcartera}`
            const fullUrlDomicilioCliente = host + `InformacionValida/obtenerDomicilioFiscalClientePorCliente/${idcliente}`
            const fullUrlActividadCliente = host + `InformacionValida/obtenerActividadClientePorCliente/${idcliente}`
            const resdomicilio = await axios.get(fullUrlDomicilioCliente)
            const resactividad = await axios.get(fullUrlActividadCliente)
            
            let datos = []
            let onjUnidos = Object.assign(res.data.data, resdomicilio.data.data)
            onjUnidos.actividad = resactividad.data.data
            let viverista = resactividad.data.data.filter(anexo=>anexo.idtipoactividad ==1)
            let productor = resactividad.data.data.filter(anexo=>anexo.idtipoactividad ==2)
            if(viverista.length>0)onjUnidos.viverista =true
            else onjUnidos.viverista = false
            if(productor.length>0)onjUnidos.productormaguey = true
            else onjUnidos.productormaguey = false
            const resdatoslogin = await axios.get(fullUrlDatosLogin)
            let datosLogin = []
            datosLogin.push(resdatoslogin.data.data)
            datos.push(onjUnidos, datosLogin)
            return datos
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_06_CONTADOR_FECHA_FOLIO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Estatus/ContadorGeneralDeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador =
                res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
                res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
                res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
                res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
                res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarFC_06Accion = createAsyncThunk(
    AGREGAR_FC_06_EXITO,
    async (data) => {
        try {
            const predios = data.predio
            const viveros = data.vivero
            const fullUrl = host + `FC_06/agregarNuevoFC_06`
            const urlAnexoPredios = host + `FC_06/agregarFormatoFC06_AnexoPredios`
            const urlAnexoViveros = host + `FC_06/agregarFormatoFC06_AnexoViveros`

            const res = await axios.post(fullUrl, { data: data.solicitud })
            let idfc06_registromaguey = res.data.data.idfc06_registromaguey

            for (let i in predios) {
                const { id, domicilio, ...anexo } = predios[i]
                anexo.idfc06_registromaguey = idfc06_registromaguey
                if (anexo.cultivado === 'Si') anexo.cultivado = true
                else { anexo.cultivado = false }
                if (anexo.semicultivado === 'Si') anexo.semicultivado = true
                else { anexo.semicultivado = false }
                if (anexo.silvestre === 'Si') anexo.silvestre = true
                else { anexo.silvestre = false }
                const result = await axios.post(urlAnexoPredios, { data: anexo })
            }
            for (let i in viveros) {
                const { id, domicilio, ...anexo } = viveros[i]
                anexo.idfc06_registromaguey = idfc06_registromaguey
                if (anexo.cultivado === 'Si') anexo.cultivado = true
                else { anexo.cultivado = false }
                if (anexo.semicultivado === 'Si') anexo.semicultivado = true
                else { anexo.semicultivado = false }
                if (anexo.silvestre === 'Si') anexo.silvestre = true
                else { anexo.silvestre = false }
                const result = await axios.post(urlAnexoViveros, { data: anexo })
            }

            //return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_06SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_06_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_06/obtenerFormatoFC06_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            const fc_06_anexopredio = []
            const documentosPredios = []
            const opcionesFilePredio = []
            for (let i in res.data.data.fc_06_anexopredio) {
                res.data.data.fc_06_anexopredio[i]['id'] = uuidv4()
                for (const j in res.data.data.fc_06_anexopredio[i].fc_06archivospredio) {
                    const { ...anexo } = res.data.data.fc_06_anexopredio[i].fc_06archivospredio[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_06archivospredio,
                        idAnexoFK: res.data.data.fc_06_anexopredio[i].idfc06_anexopredio,
                        estatus: true,
                    }
                    documentosPredios.push(data)
                    if ((anexo.nameid).includes('COPIAESC')) {
                        opcionesFilePredio.push({ id: 'PRED' + data.idAnexoFK, opcionFile: 'copiaescritura' })
                    } else if ((anexo.nameid).includes('CONSPOS')) {
                        opcionesFilePredio.push({ id: 'PRED' + data.idAnexoFK, opcionFile: 'constanciaposesion' })
                    } else if ((anexo.nameid).includes('CONARREN')) {
                        opcionesFilePredio.push({ id: 'PRED' + data.idAnexoFK, opcionFile: 'contratoarrendamiento' })
                    } else if ((anexo.nameid).includes('CONCOMPR')) {
                        opcionesFilePredio.push({ id: 'PRED' + data.idAnexoFK, opcionFile: 'contratocompraventa' })
                    } else if ((anexo.nameid).includes('CONCOMODA')) {
                        opcionesFilePredio.push({ id: 'PRED' + data.idAnexoFK, opcionFile: 'contratocomodato' })
                    }
                }
            }
            let anexosPredio = []
            for (const i in res.data.data.fc_06_anexopredio) {
                let { ...anexo } = res.data.data.fc_06_anexopredio[i]
                anexo.id = uuidv4()
                if(anexo.cultivado)anexo.cultivado='Si'
                else anexo.cultivado='No'
                if(anexo.semicultivado)anexo.semicultivado='Si'
                else anexo.semicultivado='No'
                if(anexo.silvestre)anexo.silvestre='Si'
                else anexo.silvestre='No'
                anexo.domicilio = anexo.localidad + ',' + anexo.municipio + ',' + anexo.distrito + ',' + anexo.estado,
                    anexosPredio.push(anexo)
            }
            fc_06_anexopredio.push(anexosPredio)
            const fc_06_anexovivero = []
            const documentosViveros = []
            const opcionesFileVivero = []
            for (let i in res.data.data.fc_06_anexovivero) {
                res.data.data.fc_06_anexovivero[i]['id'] = uuidv4()
                for (const j in res.data.data.fc_06_anexovivero[i].fc_06archivosvivero) {
                    const { ...anexo } = res.data.data.fc_06_anexovivero[i].fc_06archivosvivero[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_06archivosvivero,
                        idAnexoFK: res.data.data.fc_06_anexovivero[i].idfc06_anexovivero,
                        estatus: true,
                    }
                    documentosViveros.push(data)
                    if ((anexo.nameid).includes('COPIAESC')) {
                        opcionesFileVivero.push({ id: 'VIV' + data.idAnexoFK, opcionFile: 'copiaescritura' })
                    } else if ((anexo.nameid).includes('CONSPOS')) {
                        opcionesFileVivero.push({ id: 'VIV' + data.idAnexoFK, opcionFile: 'constanciaposesion' })
                    } else if ((anexo.nameid).includes('CONARREN')) {
                        opcionesFileVivero.push({ id: 'VIV' + data.idAnexoFK, opcionFile: 'contratoarrendamiento' })
                    } else if ((anexo.nameid).includes('CONCOMPR')) {
                        opcionesFileVivero.push({ id: 'VIV' + data.idAnexoFK, opcionFile: 'contratocompraventa' })
                    } else if ((anexo.nameid).includes('CONCOMODA')) {
                        opcionesFileVivero.push({ id: 'VIV' + data.idAnexoFK, opcionFile: 'contratocomodato' })
                    }

                }
            }
            let anexosVivero = []
            for (const i in res.data.data.fc_06_anexovivero) {
                const { ...anexo } = res.data.data.fc_06_anexovivero[i]
                anexo.id = uuidv4()
                await (anexo.domicilio = anexo.numeroexterior + ',' + anexo.calle + ',' + anexo.localidad + ',' + anexo.municipio + ',' +
                    anexo.distrito + ',' + anexo.estado + ',' + anexo.codigopostal)
                await anexosVivero.push(anexo)
            }

            fc_06_anexovivero.push(anexosVivero)

            return {
                data: res.data.data, fc_06_anexopredio, fc_06_anexovivero, documentosPredios,
                documentosViveros, opcionesFilePredio, opcionesFileVivero
            }
        } catch (error) {
            console.log(error);
        }
    }
)
const getNameFile = async (ruta) => {
    let nameFile = null
    const array = ruta.split("/")
    // const array = ruta.split("\\")//local
    nameFile = array[array.length - 1]
    return nameFile
}
export const agregarFileFC_06 = createAsyncThunk(
    AGREGAR_ARCHIVO_FC_06_EXITO,
    async (data) => {
        try {

            const { archivo, ruta } = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFileFC_06 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_FC_06_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const eliminarFileFC_06 = createAsyncThunk(
    ELIMINAR_ARCHIVO_FC_06_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await axios.delete(host + ruta + "/" + archivo.idAnexo)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_06Fecha = createAsyncThunk(
    AGREGAR_FC_06_FECHA_EXITO,
    async (data) => {
        try {
            const actualizarFC_06 = host + `FC_06/actualizarFC_06`
            const res = await axios.put(actualizarFC_06, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_06Estatus = createAsyncThunk(
    ACTUALIZAR_FC_06_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_06Map = createAsyncThunk(
    OBTENER_FC_06_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_06_RegistroDeMaguey/${solicitudId}`
            const res = await axios.get(fullUrl)

            const prediosMap = await obtenerProductosMap(solicitudId)

            const solicitudMap = {
                data: res.data.data,
                prediosMap: prediosMap.anexoPrediosMap,
                viverosMap: prediosMap.anexoViverosMap,
                filesPrediosMap: prediosMap.filesPrediosMap,
                filesViverosMap: prediosMap.filesViverosMap
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)

const obtenerProductosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_06/obtenerFormatoFC06_ConDetalle/${idSolicitud}`

        const obtenerPredioMap = host + `MapSolicitud/obtenerMapFC_06_AnexoPredio/`
        const obtenerArchivoPredioMap = host + `MapSolicitud/obtenerMapFC_06_ArchivosPredios/`
        const obtenerViverosMap = host + `MapSolicitud/obtenerMapFC_06_AnexoVivero/`
        const obtenerArchivoViverosMap = host + `MapSolicitud/obtenerMapFC_06_ArchivosViveros/`
        const res = await axios.get(fullUrl)
        const fc_06_anexopredio = res.data.data.fc_06_anexopredio
        const fc_06_anexovivero = res.data.data.fc_06_anexovivero
        const filesPrediosMap = []
        for (const producto of fc_06_anexopredio) {
            for (const archivo of producto.fc_06archivospredio) {
                const resfiles = await axios.get(obtenerArchivoPredioMap + archivo.idfc_06archivospredio)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_06archivospredio
                    filesPrediosMap.push(resfiles.data.data)
                }
            }
        }
        let anexoPrediosMap = []
        for (const anexo of fc_06_anexopredio) {
            const resMap = await axios.get(obtenerPredioMap + anexo.idfc06_anexopredio)
            anexoPrediosMap.push(resMap.data.data)

        }
        const filesViverosMap = []
        for (const producto of fc_06_anexovivero) {
            for (const archivo of producto.fc_06archivosvivero) {
                const resfiles = await axios.get(obtenerArchivoViverosMap + archivo.idfc_06archivosvivero)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_06archivosvivero
                    filesViverosMap.push(resfiles.data.data)
                }
            }
        }
        let anexoViverosMap = []
        for (const anexo of fc_06_anexovivero) {
            const resMap = await axios.get(obtenerViverosMap + anexo.idfc06_anexovivero)
            anexoViverosMap.push(resMap.data.data)

        }

        let Map = {
            anexoPrediosMap: anexoPrediosMap, anexoViverosMap: anexoViverosMap,
            filesPrediosMap: filesPrediosMap, filesViverosMap: filesViverosMap
        }
        return Map
    } catch (error) {
        console.log(error);
    }
}
export const actualizarFC_06Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_06_SOLICITUD,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const predios = data.predio
            const viveros = data.vivero
            const actualizarFC_06 = host + `FC_06/actualizarFC_06`
            const urlActualizarAnexoPredios = host + 'FC_06/actualizarFormatoFC06_AnexoPredios'
            const urlActualizarAnexoViveros = host + 'FC_06/actualizarFormatoFC06_AnexoViveros'

            const res = await axios.put(actualizarFC_06, solicitud)

            for (let i in predios) {
                const { id, domicilio, fc_06archivospredio, ...anexo } = predios[i]
                if (anexo.cultivado === 'Si') anexo.cultivado = true
                else { anexo.cultivado = false }
                if (anexo.semicultivado === 'Si') anexo.semicultivado = true
                else { anexo.semicultivado = false }
                if (anexo.silvestre === 'Si') anexo.silvestre = true
                else { anexo.silvestre = false }
                const result = await axios.put(urlActualizarAnexoPredios, { data: anexo })
            }
            for (let i in viveros) {
                const { id, domicilio, fc_06archivosvivero, ...anexo } = viveros[i]
                if (anexo.cultivado === 'Si') anexo.cultivado = true
                else { anexo.cultivado = false }
                if (anexo.semicultivado === 'Si') anexo.semicultivado = true
                else { anexo.semicultivado = false }
                if (anexo.silvestre === 'Si') anexo.silvestre = true
                else { anexo.silvestre = false }
                const result = await axios.put(urlActualizarAnexoViveros, { data: anexo })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_06SolicitudBorrador = createAsyncThunk(
    ACTUALIZAR_FC_06_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const predios = data.predio
            const viveros = data.vivero
            const actualizarFC_06 = host + `FC_06/actualizarFC_06`
            const urlActualizarAnexoPredios = host + 'FC_06/actualizarFormatoFC06_AnexoPredios'
            const urlActualizarAnexoViveros = host + 'FC_06/actualizarFormatoFC06_AnexoViveros'
            const urlAnexoPredios = host + `FC_06/agregarFormatoFC06_AnexoPredios`
            const urlAnexoViveros = host + `FC_06/agregarFormatoFC06_AnexoViveros`

            const res = await axios.put(actualizarFC_06, solicitud)
            let idfc06_registromaguey = res.data.data.idfc06_registromaguey

            for (let i in predios) {
                const { id, domicilio, fc_06archivospredio, ...anexo } = predios[i]
                if (anexo.cultivado === 'Si') anexo.cultivado = true
                else { anexo.cultivado = false }
                if (anexo.semicultivado === 'Si') anexo.semicultivado = true
                else { anexo.semicultivado = false }
                if (anexo.silvestre === 'Si') anexo.silvestre = true
                else { anexo.silvestre = false }
                if (anexo.idfc06_anexopredio) {
                    const result = await axios.put(urlActualizarAnexoPredios, { data: anexo })
                } else {
                    anexo.idfc06_registromaguey = idfc06_registromaguey
                    await axios.post(urlAnexoPredios, { data: anexo })
                }

            }
            for (let i in viveros) {
                const { id, domicilio, fc_06archivosvivero, ...anexo } = viveros[i]
                if (anexo.cultivado === 'Si') anexo.cultivado = true
                else { anexo.cultivado = false }
                if (anexo.semicultivado === 'Si') anexo.semicultivado = true
                else { anexo.semicultivado = false }
                if (anexo.silvestre === 'Si') anexo.silvestre = true
                else { anexo.silvestre = false }
                if (anexo.idfc06_anexovivero) {
                    const result = await axios.put(urlActualizarAnexoViveros, { data: anexo })
                } else {
                    anexo.idfc06_registromaguey = idfc06_registromaguey
                    await axios.post(urlAnexoViveros, { data: anexo })
                }

            }

        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarFC_06AnexoPredioBD = createAsyncThunk(
    ELIMINAR_FC_06_ANEXOPREDIO_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_06/eliminarFormatoFC06_AnexoPredios/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)
export const eliminarFC_06AnexoViveroBD = createAsyncThunk(
    ELIMINAR_FC_06_ANEXOVIVERO_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_06/eliminarFormatoFC06_AnexoViveros/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)

export const registrarSolicitudFC_06AnexoPredioAccion = createAsyncThunk(
    FC_06_ANEXO_PREDIO_SOLICITUD_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `FC_06/agregarFormatoFC06AnexoPredio`
            const res = await axios.post(fullUrl, { data })
            return { data: res.data.data }
        } catch (error) {
            console.log(error)
        }
    }
)

export const eliminarFC_06SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_06_SOLICITUD_EXITO_BD,
    async (id) => {
        try {
            const fullUrlSolicitud = host + `FC_06/eliminarFC_06/${id}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return { id }
        } catch (error) {
            console.log(error);
        }
    }
)

export const fc06Slice = createSlice({
    name: 'fc06Slice',
    initialState: dataInicial,
    reducers: {
        actualizarFC_06PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },

        guardarCambiosFC_06SolicitudBorrador(state, { payload }) {
            state.data = payload
        },
        guardarCambiosFC_06SolicitudNueva(state, { payload }) {
            state.fc_06 = payload
        },
        actualizarModoBorradorFC_06(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        actualizarModoCorrecionFC_06(state, { payload }) {
            state.modoCorreccion = payload
        },
        resetDataFC_06(state, { payload }) {
            return dataInicial
        },

    },
    extraReducers: {
        [ObtenerClientePorLogin06.fulfilled]: (state, { payload }) => {
            let numInt = ''
            let numExt = ''
            let colonia = ''
            if (payload[0].numerointerior === '' || payload[0].numerointerior === null) numInt = 's/n'
            else numInt = payload[0].numerointerior
            if (payload[0].numeroexterior === '' || payload[0].numeroexterior === null) numExt = 's/n'
            else numExt = payload[0].numeroexterior
            if (payload[0].colonia === '' || payload[0].colonia === null) colonia = 's/n'
            else colonia = payload[0].colonia
            state.cliente = payload[0]
            state.fc_06.domiciliosolicitante = payload[0].calle + ',' + numInt + ',' + numExt + ',' + colonia + ',' + payload[0].localidad + ',' +
                payload[0].municipioalcaldia + ',' + payload[0].estado + ',' + payload[0].codigopostal
            state.domiclio = payload[0].calle + ',' + numInt + ',' + numExt + ',' + colonia + ',' + payload[0].localidad + ',' +
                payload[0].municipioalcaldia + ',' + payload[0].estado + ',' + payload[0].codigopostal
            state.dataLogin = payload[1][0][0]
        },
        [obtenerFC_06SolicitudDetalle.fulfilled]: (state, { payload }) => {
            state.data = payload.data
            state.fc_06 = payload.data
            state.dataDocumentacion = payload.data
            state.filesPredios = { data: payload.documentosPredios }
            state.filesViveros = { data: payload.documentosViveros }
            state.predios = payload.fc_06_anexopredio
            state.viveros = payload.fc_06_anexovivero
            state.opcionesFilePredio = payload.opcionesFilePredio
            state.opcionesFileVivero = payload.opcionesFileVivero
        },
        [obtenerFC_06Map.fulfilled]: (state, { payload }) => {
            state.fc_06Map = payload.data
            state.prediosMap = payload.prediosMap
            state.viverosMap = payload.viverosMap
            state.filesPrediosMap = payload.filesPrediosMap
            state.filesViverosMap = payload.filesViverosMap
        },



    },
})

//actions
export const {
    actualizarFC_06PaginaActiva,


    actualizarModoBorradorFC_06,
    actualizarModoCorrecionFC_06,
    guardarCambiosFC_06SolicitudBorrador,
    guardarCambiosFC_06SolicitudNueva,
    resetDataFC_06,
    agregarFC_06AnexoPredio,
    agregarFC_06Predio,
    editarFC_06AnexoPredio
} = fc06Slice.actions

export const FC06ReducerBeneficiario = fc06Slice.reducer
